import React from "react";

import ServiceThreeAbout from "components/abouts/service-3-about";
import AgencyCta from "components/cta/agency-cta";
import SEO from "components/seo";
import ServiceThreeServices from "components/services/service-3-services";
import ServiceThreeVideoArea from "components/video-area/service-3-video-area";
import FooterSeven from "layout/footers/footer-7";
import HeaderSix from "layout/headers/header-6";
import Wrapper from "layout/wrapper";
import CalenderThree from "svg/calender-3";
import CommentBigTwo from "svg/comment-big-2";

import bannerIcon from "assets/img/Main Images/2D/rionickicon.png";
import bannerImage from "assets/img/Main Images/2D/video-bg-2.jpg";
import game2dImage from "assets/img/Main Images/2D/2D Game User interface.jpg";
import game3dImage from "assets/img/Main Images/3d/3d animation services.jpg";

const gameServices = [
  {
    icon: <i className="fa-solid fa-gamepad"></i>,
    title: "2D Mobile Game Development",
    subtitle:
      "We create polished 2D mobile games with expressive artwork, intuitive controls, responsive interfaces, and engaging gameplay loops.",
  },
  {
    icon: <i className="fa-solid fa-cube"></i>,
    title: "3D Mobile Game Development",
    subtitle:
      "We build immersive 3D games with optimized environments, characters, animation, lighting, and performance across mobile devices.",
  },
  {
    icon: <CalenderThree />,
    title: "Unity Gameplay Development",
    subtitle:
      "Our Unity developers turn game concepts into reliable systems, mechanics, progression, multiplayer features, and playable experiences.",
  },
  {
    icon: <CommentBigTwo />,
    title: "Testing and Live Support",
    subtitle:
      "We provide gameplay testing, performance optimization, deployment assistance, updates, and ongoing support after launch.",
  },
];

const GameDevelopment = () => {
  return (
    <Wrapper>
      <SEO
        metaTitle="Game Development Company in India | 2D & 3D Unity Games"
        metaDesc="Rionick creates engaging 2D and 3D mobile games in Unity, including gameplay programming, game UI, testing, optimization, deployment, and support."
        metaKeywords="game development company India, mobile game development, Unity game development, 2D game development, 3D game development, game UI design"
        canonical="https://www.rionick.com/game-development-services-india"
        pageTitle="Game Development"
      />
      <HeaderSix top_bar={false} commonOffCanvas={true} />
      <ServiceThreeVideoArea
        banner_icon={bannerIcon}
        video_bg={bannerImage}
        t1="Games built for engagement."
        t2="End-to-end 2D and 3D Game Development Services"
      />
      <ServiceThreeServices list={gameServices} />
      <ServiceThreeAbout
        t1="2D game development for engaging mobile experiences"
        p="We design and develop visually appealing 2D games in Unity with responsive controls, clear interfaces, memorable characters, and gameplay tailored to your audience and business goals."
        reverse={true}
        about_img={game2dImage}
      />
      <ServiceThreeAbout
        t1="Immersive 3D games built and optimized in Unity"
        p="From early prototypes to launch-ready builds, we create 3D environments, characters, animation, gameplay systems, and optimized mobile performance that bring your game idea to life."
        reverse={false}
        about_img={game3dImage}
      />
      <AgencyCta
        content="Have a game idea?"
        title="Turn your concept into an engaging playable experience"
        btext="Get in touch"
        bclr="tp-btnr bg-danger tp-btn-shine-effect"
        element_style={true}
      />
      <FooterSeven />
    </Wrapper>
  );
};

export default GameDevelopment;
